<template>
  <header :class="[isNewClass, layoutVersion]">
    <section class="header-app-info">
      <img :src="imgUrl" alt="Toplupe-logo" />
    </section>
    <section class="btn-wrap">
      <RegionLangPopup page="home" />
      <UserCenter page="home" @login="getLoginResult" ref="loginComp" />
    </section>
  </header>
</template>
<script>
  import UserCenter from '@/components/UserCenter'
  import RegionLangPopup from '@/components/RegionLangPopup'
  import { mapState, mapGetters } from 'vuex'

  export default {
    components: {
      UserCenter,
      RegionLangPopup,
    },
    computed: {
      ...mapState(['layoutVersion']),
      ...mapGetters(['isNew', 'isNewClass']),
      imgUrl() {
        if (this.isNew) {
          return require('@/assets/images/detail/mobile-legends/desktop/new-hander-logo.png')
        } else if (this.layoutVersion === 'version-2-2') {
          return require('@/assets/images/common/home_logo-2.png')
        }
        return require('@/assets/images/common/home_logo.png')
      },
    },
    mounted() {},
    methods: {
      login({ type = '' }) {
        this.$refs.loginComp && this.$refs.loginComp.loginBtn(type)
      },
      getLoginResult(res) {
        this.$emit('login', res)
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index.scss';
  }
</style>
